export default {
  steps: {
    setup_fee: 'Opłata konfiguracyjna',
    business_info: 'Dane firmy',
    create_preview: 'Utwórz podgląd umowy',
    preview: 'Podgląd umowy',
    sign: 'Podpisz umowę',
  },
  buttons: {
    next: 'Podgląd umowy',
    save_and_continue: 'Zapisz i kontynuuj',
    update: 'Aktualizuj podgląd',
    cancel: 'Anuluj bieżącą',
    skip: 'Pomiń tworzenie umowy',
  },
  create_preview: {
    header: 'Utwórz podgląd umowy',
    description: 'Wprowadź dane odbiorcy umowy. Możesz je jeszcze zmienić przed wysłaniem.',
  },
  sign: {
    update_notice: 'Aby zaktualizować umowę, anuluj bieżącą i edytuj dane.',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
  },
};
